import { render, staticRenderFns } from "./RecordingReport.vue?vue&type=template&id=10a8547e&scoped=true&"
import script from "./RecordingReport.vue?vue&type=script&lang=js&"
export * from "./RecordingReport.vue?vue&type=script&lang=js&"
import style0 from "./RecordingReport.vue?vue&type=style&index=0&id=10a8547e&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10a8547e",
  null
  
)

export default component.exports